import styled from "styled-components";
import { WithThemeType } from "@/types/WithThemeType";

export const OTTInfoMessage = styled.p<WithThemeType>`
  margin-top: 2rem;
  background-color: ${({ theme }) => theme.colors.navigationBackground};
  padding: 0.5rem 1rem;
  border-radius: 0.5rem;
`;
